import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockUser, mockListings, mockWtbRequests } from '../../mockData';
import BoostModal from '../common/BoostModal';
import './Pages.css';

function UserProfilePage() {
  // eslint-disable-next-line no-unused-vars
  const { userId } = useParams();
  
  // State for boost modal
  const [isBoostModalOpen, setIsBoostModalOpen] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  
  // Use the mock user data
  const user = mockUser;
  
  // Open boost modal for a listing
  const handleBoostClick = (e, listing) => {
    e.preventDefault(); // Prevent navigation to listing detail
    e.stopPropagation(); // Prevent event bubbling
    setSelectedListing(listing);
    setIsBoostModalOpen(true);
  };
  
  // Close boost modal
  const closeBoostModal = () => {
    setIsBoostModalOpen(false);
    setSelectedListing(null);
  };
  
  // Mock reviews data
  const mockReviews = [
    {
      id: 'rev001',
      reviewerId: 'buyer789',
      reviewerUsername: 'HappyBuyer',
      reviewerAvatar: 'https://randomuser.me/api/portraits/men/3.jpg',
      rating: 5,
      comment: 'Great seller! Item was exactly as described and shipped very quickly. Would definitely buy from again!',
      date: '2025-02-15'
    },
    {
      id: 'rev002',
      reviewerId: 'techguru101',
      reviewerUsername: 'TechGuru',
      reviewerAvatar: 'https://randomuser.me/api/portraits/women/4.jpg',
      rating: 4,
      comment: 'Good communication and fast shipping. The item had a small scratch not mentioned in the listing, but overall a positive experience.',
      date: '2025-03-02'
    },
    {
      id: 'rev003',
      reviewerId: 'gadgetpro',
      reviewerUsername: 'GadgetPro',
      reviewerAvatar: 'https://randomuser.me/api/portraits/men/5.jpg',
      rating: 5,
      comment: 'Excellent transaction! Fair price and the item was in even better condition than expected. Highly recommend this seller.',
      date: '2025-03-20'
    }
  ];
  
  // Create some additional mock listings to ensure display
  const additionalUserListings = [
    {
      id: 'user-list001',
      title: 'Gaming PC - RTX 3080, Ryzen 9',
      description: 'High-end gaming PC with RTX 3080, Ryzen 9 5900X, 32GB RAM, 2TB SSD. Used for 6 months, in perfect condition.',
      price: 12500,
      condition: 'Fully Working',
      category: 'Computers',
      imageUrl: 'https://images.unsplash.com/photo-1587202372775-e229f172b9d7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
      sellerId: user.id,
      sellerUsername: user.username,
      isAuction: false,
      location: 'Hong Kong Island',
      postedDate: '2025-03-10',
      views: 87
    },
    {
      id: 'user-list002',
      title: 'Sony WH-1000XM4 Headphones',
      description: 'Sony WH-1000XM4 wireless noise-cancelling headphones. Black color, including case and all accessories. Barely used.',
      price: 1800,
      condition: 'Like New',
      category: 'Audio',
      imageUrl: 'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1388&q=80',
      sellerId: user.id,
      sellerUsername: user.username,
      isAuction: false,
      location: 'Kowloon',
      postedDate: '2025-03-25',
      views: 34
    },
    {
      id: 'user-list003',
      title: 'iPad Pro 12.9" (2021) - 256GB',
      description: 'iPad Pro 12.9" 2021 model with M1 chip. 256GB storage, WiFi + Cellular. Space Grey with Apple Pencil 2 included.',
      price: 7200,
      condition: 'Fully Working',
      category: 'Mobile Phones',
      imageUrl: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80',
      sellerId: user.id,
      sellerUsername: user.username,
      isAuction: true,
      currentBid: 6000,
      endTime: '2025-04-10T15:00:00',
      location: 'New Territories',
      postedDate: '2025-03-15',
      views: 56
    }
  ];
  
  // Filter listings that belong to this user from the mock data
  const mockUserListings = mockListings.filter(listing => listing.sellerId === user.id);
  
  // Combine with additional listings to ensure display
  const userListings = [...mockUserListings, ...additionalUserListings];
  
  // Filter WTB requests that belong to this user
  const userWtbRequests = mockWtbRequests.filter(request => request.userId === user.id);
  
  // Star rating component
  const StarRating = ({ rating }) => {
    return (
      <div className="star-rating">
        {[...Array(5)].map((_, i) => (
          <span key={i} className={i < rating ? 'star filled' : 'star'}>★</span>
        ))}
      </div>
    );
  };
  
  return (
    <div className="page user-profile-page">
      <div className="profile-header">
        <div className="profile-avatar">
          <img src={user.avatar} alt={user.username} />
        </div>
        <div className="profile-info">
          <div className="profile-header-top">
            <h1>{user.username}</h1>
            <button className="action-button update-profile-button">Update Profile</button>
          </div>
          <p className="join-date">Member since {new Date(user.joinDate).toLocaleDateString()}</p>
          <p className="user-email">{user.email}</p>
        </div>
      </div>
      
      <div className="profile-details">
        <div className="profile-section">
          <h2>My Listings</h2>
          {userListings.length > 0 ? (
            <div className="user-listings-grid">
              {userListings.map(listing => (
                <Link to={`/listing/${listing.id}`} key={listing.id} className="listing-card">
                  <div className="listing-image">
                    <img src={listing.imageUrl} alt={listing.title} />
                    {listing.isAuction && <span className="auction-badge">Auction</span>}
                    <button 
                      className="boost-listing-button"
                      onClick={(e) => handleBoostClick(e, listing)}
                    >
                      Boost
                    </button>
                  </div>
                  <div className="listing-info">
                    <h3 className="listing-title">{listing.title}</h3>
                    <p className="listing-price">HK${listing.price}</p>
                    <div className="listing-details">
                      <span>{listing.condition}</span>
                      <span>{listing.location}</span>
                    </div>
                    <div className="listing-meta">
                      <span className="listing-views">{listing.views} views</span>
                      <span className="listing-date">Posted: {new Date(listing.postedDate).toLocaleDateString()}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="no-items-message">No listings found.</p>
          )}
        </div>

        <div className="profile-section">
          <h2>My WTB Requests</h2>
          {userWtbRequests.length > 0 ? (
            <div className="wtb-requests-grid">
              {userWtbRequests.map(request => (
                <div key={request.id} className="wtb-request-card">
                  <div className="wtb-request-header">
                    <h3 className="wtb-request-title">{request.title}</h3>
                    <div className="wtb-request-price-range">
                      <span className="price-label">Budget:</span> {request.priceRange}
                    </div>
                  </div>
                  <div className="wtb-request-details">
                    <p className="wtb-request-description">{request.description}</p>
                    <div className="wtb-request-meta">
                      <div>
                        <span className="meta-label">Category:</span> {request.category}
                      </div>
                      <div>
                        <span className="meta-label">Condition:</span> {request.desiredCondition}
                      </div>
                      <div>
                        <span className="meta-label">Posted:</span> {new Date(request.postedDate).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-items-message">No WTB requests found.</p>
          )}
        </div>
        
        <div className="profile-section">
          <h2>Reviews</h2>
          <div className="reviews-container">
            {mockReviews.length > 0 ? (
              <div className="reviews-list">
                {mockReviews.map(review => (
                  <div key={review.id} className="review-item">
                    <div className="review-header">
                      <div className="reviewer-info">
                        <img src={review.reviewerAvatar} alt={review.reviewerUsername} />
                        <div>
                          <span className="reviewer-name">{review.reviewerUsername}</span>
                          <span className="review-date">{new Date(review.date).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <StarRating rating={review.rating} />
                    </div>
                    <p className="review-comment">{review.comment}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-items-message">No reviews yet.</p>
            )}
          </div>
        </div>
      </div>
      
      {/* Boost Modal */}
      {selectedListing && (
        <BoostModal 
          isOpen={isBoostModalOpen}
          onClose={closeBoostModal}
          listing={selectedListing}
        />
      )}
    </div>
  );
}

export default UserProfilePage; 